import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { AddressesListResponse, UserAddressInput } from '../../types/api';
import type { UserAddress } from '../../types';

export async function httpFetchAddresses(): Promise<UserAddress[]> {
  const response = await apiClient<AddressesListResponse | UserAddress[]>(endpoints.addresses.list);
  return Array.isArray(response) ? response : response.addresses;
}

export async function httpCreateAddress(input: UserAddressInput): Promise<UserAddress> {
  return apiClient<UserAddress>(endpoints.addresses.create, {
    method: 'POST',
    body: input,
  });
}

export async function httpUpdateAddress(id: string, input: UserAddressInput): Promise<UserAddress> {
  return apiClient<UserAddress>(endpoints.addresses.update(id), {
    method: 'PUT',
    body: input,
  });
}

export async function httpDeleteAddress(id: string): Promise<void> {
  await apiClient<void>(endpoints.addresses.delete(id), { method: 'DELETE' });
}

export async function httpSetDefaultShipping(id: string): Promise<UserAddress> {
  return apiClient<UserAddress>(endpoints.addresses.defaultShipping(id), { method: 'PATCH' });
}

export async function httpSetDefaultBilling(id: string): Promise<UserAddress> {
  return apiClient<UserAddress>(endpoints.addresses.defaultBilling(id), { method: 'PATCH' });
}
